import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import { FC } from 'react';

import { ProductContentForm } from './product-content-form';
import { styles } from './product-content-subsection.styles';

interface IProductContentSubsectionProps {
  productIndex: number;
}

export const ProductContentSubsection: FC<IProductContentSubsectionProps> = ({ productIndex }) => {
  return (
    <Accordion defaultExpanded disableGutters sx={styles.accordion}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={styles.accordionSummary}>
        <Box sx={styles.accordionHeader}>
          <Typography fontWeight={600} variant="subtitle1">Content</Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={styles.accordionDetails}>
        <ProductContentForm productIndex={productIndex} />
      </AccordionDetails>
    </Accordion>
  );
};
